import styled from 'styled-components';

import Select from 'components/Select';

import { Flexer, Spacer } from '@ontruck/orc';

export const StyledHelpText = styled.div`
  color: var(--greyWolf);
`;

export const StyledFieldWrapper = styled(Flexer.Child)`
  display: ${(props) => (props.visible ? 'block' : 'none')};
  ${(props) => (props.fullWidth && 'width: 100%;') || ''}
`;

export const StyledFirstColumn = styled(Flexer.Child)`
  width: 100%;
  max-width: 460px;
`;

export const StyledExtrasHeader = styled(Flexer.Parent).attrs(() => ({
  alignItems: 'center',
}))`
  color: var(--greyWolf);
  background: #eff2f6;
`;

export const StyledExtrasHeaderColumn = styled.div`
  padding: 8px;
  font-size: 14px;
  margin-right: ${({ position }) => (position === 'left' ? 'auto' : 0)};
  margin-left: ${({ position }) => (position === 'right' ? 'auto' : 0)};
`;

export const StyledExtrasTitle = styled.div`
  font-size: 18px;
  color: var(--grey900);
  font-weight: bold;
`;

export const StyledExtrasGroup = styled(Spacer).attrs(() => ({ mBottom: 'M' }))`
  background: #fff;
`;

export const StyledExtraContainer = styled.div`
  border: 1px solid var(--greyWolf);
  border-bottom-width: ${({ isLast }) => (isLast ? '1px' : 0)};
`;

export const StyledExtraNoWrapChild = styled(Flexer.Child)`
  white-space: nowrap;
`;

export const StyledSelect = styled(Select)`
  width: 72px;
`;

export const ModifiedPriceExtraStyles = (Component) => styled(Component)`
  background: #fff;
  .first-column {
    width: 100%;
    max-width: 444px;

    label {
      span {
        font-size: 14px;
      }
    }
  }

  .sublabel {
    color: var(--grey500);
    font-size: 12px;
    position: absolute;
    top: 36px;
    left: 45px;
  }

  .container {
    height: 68px;
    position: relative;
    display: flex;
    padding: 16px;
    align-items: center;
    flex: 1;
  }

  .inner-container {
    width: 100%;
    display: flex;
    flex: 1;
  }
  .inner-options-container {
    display: flex;
    align-items: center;

    // ORC checkboxes overwrite
    label {
      margin-bottom: 0;
      margin-right: 25px;

      span:first-child {
        border-radius: 50px;
      }
    }
  }
  .tenant-field  {
    position: absolute;
    right: 16px;
    top: calc(34px - 3.2rem / 2);
  }
  .inner-field-container {
    width: 11.2rem;

    span {
      top: 1px;
    }
  }
`;

export const ReturnExtraStyles = (Component) => styled(Component)`
  background: #fff;
  .container {
    height: 53px;
    display: flex;
    padding-right: 16px;
    align-items: center;
    flex: 1;

    label {
      span {
        font-size: 14px;
      }
    }
  }

  .inner-container {
    width: 100%;
    display: flex;
    flex: 1;
  }

  .inner-options-container {
    display: flex;
    align-items: center;
  }

  .inner-field-container {
    width: 104px;

    span {
      top: 1px;
    }
  }
`;
